import { useEffect } from 'react';

import { HYDRATION_COMPLETE_EVENT } from './hydrationEvents';

/** Runs after React commits the hydrated document; unlike Remix internals, this marks actual UI readiness. */
export function markHydrationComplete(target: Window = window): void {
  (target as Window & { __akHydrationComplete?: boolean }).__akHydrationComplete = true;
  target.dispatchEvent(new Event(HYDRATION_COMPLETE_EVENT));
}

export function HydrationMarker() {
  useEffect(() => {
    markHydrationComplete();
  }, []);

  return null;
}
